import { Column, Img, Link, Row, Section } from '@react-email/components'
import { baseUrl } from 'utils'

import { typography } from 'ms-email/themes/typography'
import { assetUrlOf } from 'ms-email/utils/asset-url-of'

import { Text } from './Text'

export function Footer() {
  const socials = [
    {
      name: 'Youtube',
      url: 'https://www.youtube.com/channel/UCZE-1UGZKZITlg7D49eMMqA',
      icon: assetUrlOf('public/emails/socials/icon-rounded-youtube.png')
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/mapstack_io',
      icon: assetUrlOf('public/emails/socials/icon-rounded-twitter.png')
    },
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/mapstack.io',
      icon: assetUrlOf('public/emails/socials/icon-rounded-facebook.png')
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/company/mapstack/',
      icon: assetUrlOf('public/emails/socials/icon-rounded-linkedin.png')
    }
  ]

  return (
    <Section style={{ marginTop: 32 }}>
      <Row>
        <Column align='left'>
          <Img
            src={assetUrlOf('public/emails/logos/icon-mapstack-32px.png')}
            alt='mapstack'
            width='auto'
            style={{ height: 32 }}
          />
        </Column>
        <Column align='right'>
          {socials.map((social, index) => {
            return (
              <Link
                key={index}
                href={social.url}
                style={{
                  display: 'inline-block'
                }}
              >
                <Img
                  src={social.icon}
                  alt={social.name}
                  width={30}
                  height={30}
                  style={{ marginLeft: '12px' }}
                />
              </Link>
            )
          })}
        </Column>
      </Row>
      <Row style={{ marginTop: 32 }}>
        <Column>
          <Text style={typography.caption}>
            @2022 mapstack 1 Victoria Street, Bristol, England, BS1 6AA, UK
          </Text>
        </Column>
      </Row>
      <Row style={{ paddingTop: 8 }}>
        <Column>
          <Link
            href={`${baseUrl()}/privacy`}
            style={{
              ...typography.caption,
              display: 'inline-block',
              textDecoration: 'none'
            }}
          >
            Privacy
          </Link>
          <Text
            style={{
              ...typography.caption,
              display: 'inline-block'
            }}
          >
            &nbsp;
          </Text>
          <Link
            href={`${baseUrl()}/privacy`}
            style={{
              ...typography.caption,
              display: 'inline-block',
              textDecoration: 'none'
            }}
          >
            Terms
          </Link>
        </Column>
      </Row>
    </Section>
  )
}
